import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import EndUser from './../utils/resources/ModuleIcons/FinalUSer.gif'

const EndUserPage = () => {
    const { t } = useTranslation();
    const user = useSelector(selectUser)
    const context: IOutletContext = useOutletContext();

    useEffect(() => {
        context.setState(t('EndUser'));
    }, [context, t]);



    return (
        <>
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>

                <div className='col p-1'>
                    <div className="mt-1 py-2 px-4 pt-4 d-flex flex-column rounded-1 justify-content-center align-items-center " style={{ backgroundColor: 'var(--background-secondary)', height: '85vh',boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)' }}>
                        <img src={EndUser} height={'100%'} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default EndUserPage;
